import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class OxidationReductionPotentialSensorNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.OxidationReductionPotentialSensor,
    });
  }
}
